import React, {Component} from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import axios from "axios";
import {authService} from "../../../auth";
import * as _ from "lodash";
import {setProjectDetails} from "../../../reducer/showAllReducer";
import {connect} from "react-redux";
import uuid from "react-uuid";
import mappingUtils from "../../component/commons/utils/mappingUtils";
import {getCDNUrl} from "../../../commons/CommonFunctions";
import AutoComplete from "../../component/commons/Autocomplete";
import {WithContext as ReactTags} from "react-tag-input";
import OutSideWNEmailConfirmPopUp from "../../../commons/OutSideWNEmailConfirmPopUp";
import InfiniteScroll from "react-infinite-scroller";
import AllowRestrictRemoveBtn from "./AllowRestrictRemoveBtn";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import CleverTapUtils from "../../../commons/CleverTapUtils";

class ProjectFacultyContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            inviteeList: [],
            pageSize: 6,
            pageNo: 0,
            tags: [],
            pagination: false,
            project: props.project,
            faculties: [],
            projectDetail: {},
            messageEmailSent :"",
            uniqueKeyInvite: uuid(),
            uniqueKeyPending: uuid(),
            donationEntityConfig: {},
            invitePlacementData:(props.projectDetail && props.projectDetail.participationDetails && (props.projectDetail.participationDetails.secondaryEntityType==='EVENT' || props.projectDetail.participationDetails.secondaryEntityType==='FUNDRAISE'
                || props.projectDetail.participationDetails.secondaryEntityType==='STORYBOOK' )?'Invite New Speaker':props.projectDetail.participationDetails.secondaryEntityType==='EXPEDITION' ? ' Invite New Leader' : 'Invite New Faculty' ),
            invitePopUpPlacementData:(props.projectDetail && props.projectDetail.participationDetails && (props.projectDetail.participationDetails.secondaryEntityType==='EVENT' || props.projectDetail.participationDetails.secondaryEntityType==='FUNDRAISE'
                ||props.projectDetail.participationDetails.secondaryEntityType==='STORYBOOK')?'Add speaker ':
                props.projectDetail.participationDetails.secondaryEntityType==='EXPEDITION' ?  'Add Leader' :  'Add faculty ')


        }

        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentWillUnmount() {
        window.$('#confirmPopupInvite' + this.state.uniqueKeyInvite + this.state.currentIndex).modal('hide');
        window.$('#projectDetails').modal('hide');
        window.$('#confirmPopupPending' + this.state.uniqueKeyPending).modal('hide');
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.projectDetail !== nextProps.projectDetail) {
            this.setState({'projectDetail': nextProps.projectDetail}, () => {
                this.getFacultiesSuggestion();
                window.$(".outsdinvfrndhdr").click(function () {
                    window.$(".outsdinvfrndbdy").slideToggle("slow");
                    window.$(".outsdinvfrndhdr").toggleClass("active");
                });


            });
        }

    }

    redirectToProfile = (customUrl) => {
        window.location.href = "/profile/" + customUrl;
    }

    getOptimizedImage(data) {
        if (data.resizedProfileImages && data.resizedProfileImages['200x200'] != null) {
            return data.resizedProfileImages['200x200'];
        }
        return data.originalProfileImage;
    }

    withdrawFacultyRequest = (user) => {
        let postData = {
            projectId: this.props.projectId,
            userId: user.userId
        }
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/participation/withdraw-invitee-request',
            data: postData,
            header: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            if (response && response.data && response.data.status === '202 ACCEPTED') {
                this.getFacultyList(true);
                window.$('#Withdraw' + user.id).modal('hide');
            }
        }).catch((err) => {
            console.log(err)
        })

    }



    ignoreModalPending = () => {
        window.$('#confirmPopupPending' + this.state.uniqueKeyPending + this.state.currentIndex).modal('hide')
    }




    componentDidMount() {
        window.$(".outsdinvfrndhdr").click(function () {
            window.$(".outsdinvfrndbdy").slideToggle("slow");
            window.$(".outsdinvfrndhdr").toggleClass("active");
        });
        this.getFacultyList();
        this.getFacultiesSuggestion();

        window.$('.projgeneralsec .collapse').on('shown.bs.collapse', function () {
            window.$(this).parent().addClass('active');
        });

        window.$('.projgeneralsec .collapse').on('hidden.bs.collapse', function () {
            window.$(this).parent().removeClass('active');
        });
    }

    onChangeHandlerByNameAndValue = (name, value, imgUrl, id,userType) => {
        let e = {target: {}};
        e["target"]["name"] = name;
        e["target"]["value"] = value;
        e["target"]["url"] = imgUrl;
        e["target"]["id"] = id;
        e["target"]["userType"] = userType;

        this.onChangeHandler(e);
    };


    onChangeHandler = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let url = event.target.url;
        let id = event.target.id;
        let userType = event.target.userType;
        this.setFormFieldValue(name, value, url, id,userType);
    };

    setFormFieldValue = (name, value, url, id,userType) => {
        if (name == "participant") {
            let participants = this.state.faculties.filter(
                (participant) => participant.id.toLowerCase().indexOf(id.toLowerCase()) < 0
            );

            participants.push({value, url, id,userType});
            this.setState({faculties: participants});
            this.setState({
                'facultiesSuggestion': this.state.facultiesSuggestion.filter(
                    (fac) => {
                        return id !== fac.id;
                    }
                )
            })
        }
    };

    f

    removeParticipants(faculty) {
        this.setState({
            faculties:
                this.state.faculties.filter(
                    (fac) => {
                        return faculty.id !== fac.id;
                    }
                ),

        });
        let facultiesSuggestion = this.state.facultiesSuggestion;
        faculty.img = faculty.url;
        facultiesSuggestion.push(faculty);
        this.setState({'facultiesSuggestion': facultiesSuggestion});
    }


    getFacultiesSuggestion() {
        let url;
        url =
            process.env.REACT_APP_userServiceURL +
            "/participants/faculty-suggestions/" +
            authService.getUserDetailsFromLocalStorage().userId +
            "?creatorUserId=" +
            authService.getUserDetailsFromLocalStorage().userId +
            "&projectId=" +
            this.props.projectId +
            "&entityType=" +
            mappingUtils.getUserType(authService.getUserDetailsFromLocalStorage());
        axios({
            method: "get",
            url: url,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                    let userInfos = response.data.body;
                    let faculties = [];
                    userInfos.map((userInfo) => {
                        let user = {
                            value: userInfo.username,
                            img:
                                userInfo.personalInfo &&
                                userInfo.personalInfo.profileImage &&
                                !_.isNull(userInfo.personalInfo.profileImage)
                                    ? userInfo.personalInfo.profileImage
                                    : mappingUtils.returnDefaultImage(userInfo.type),
                            id: userInfo.id,
                            type:userInfo.type
                        };
                        faculties.push(user);
                    });
                    this.setState({ facultiesSuggestion: faculties });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    removefaculties = (event) => {
        event.preventDefault();
        this.setState({'faculties': [],'inputReset':true});
        this.getFacultiesSuggestion();

    };

    fetchMoreFacultyList = () => {
        this.setState({isResultLoading: true, pageNo: this.state.pageNo + 1}, () => {
            this.getFacultyList(false);
        })

    };


    getFacultyList = (renew) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/participants/faculty-list/'
                + this.props.projectId +'/'+this.state.userData.userId+ "?page=" + this.state.pageNo + "&size=" + this.state.pageSize,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.data.message === 'Success!') {
                let inviteeList;
                if (renew) {
                    inviteeList = [];
                } else {
                    inviteeList = this.state.inviteeList;
                }

                inviteeList.push(...response.data.body.content);
                this.setState({
                    'inviteeList': inviteeList,
                    'pagination': !response.data.body.last,
                    isResultLoading: false
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    };




    sendParticipantRequest = (event) => {
        event.preventDefault();
        let title;
        let projectCreatorId;
        let projectType;
        let proj = this.props.projectDetail && this.props.projectDetail.project;
        if (proj) {
            title = proj.jobTitle || proj.sessionTitle || proj.assignmentTitle || proj.jobTitle || proj.title;
            if (this.props.projectDetail && this.props.projectDetail.participationDetails && this.props.projectDetail.participationDetails.creatorUserId && this.props.projectDetail.participationDetails.creatorUserId === this.state.userData.userId) {
                projectCreatorId = this.props.projectDetail.participationDetails.creatorUserId;
            } else {
                projectCreatorId = proj.userId;
            }
            projectType = this.props.projectDetail && this.props.projectDetail.participationDetails && this.props.projectDetail.participationDetails.secondaryEntityType;
        }

        let userIds = [];
        for (let data of this.state.faculties) {
            userIds.push(data.id);
        }
        event.preventDefault();
        let postBody = {

            "projectId": this.props.projectId,
            "projectCreatorId": this.state.userData.userId,
            "title": title,
            "userIds": userIds,
            "projectType": projectType
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/participation/faculty/send/request',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                this.setState({faculties: []});
                window.$('#newInvitepeople').modal('hide');
                this.getFacultiesSuggestion();
                this.setState({
                    'pendingPageNo': 0,
                    'pendingPageSize': 6,
                    'pageNo': 0,
                    'pageSize': 6,
                    'pendingParticipantsFetched': false
                }, () => {
                    this.getFacultyList(true);
                })
            }
        }).catch((err) => {

        });

    };

    openWidhdrawModal = (id) => {
        window.$('#Withdraw' + id).modal('show');
    }

    componentWillUnmount() {
        this.state.inviteeList && this.state.inviteeList.map((user, index) => {
            if (window.$('#Withdraw' + user.id)) {
                window.$('#Withdraw' + user.id).modal('hide');
            }
        })
        window.$('#newInvitepeople').modal('hide');
        window.$('.modal-backdrop').remove();
    }

    sendEmailToOutsideWN = (event) => {
        event.preventDefault();
        this.setState({'sendOutSideWNEmailDisabled': true});
        let emails = [];
        this.state.tags.forEach((tag) => {
            emails.push(tag.text);
        })
        let postBody = {
            "emails": emails,
                "invitationType" : "FACULTY",
            "approverId": this.state.userData.userId,
            "projectId": this.props.projectId,
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/backend/participation/outside/save',
            headers: {'Content-Type': 'application/json'},
            data: postBody,
            withCredentials: true
        }).then((response, dispatch) => {
            let res = response.data;
            if (res.status === '201 CREATED') {
                this.setState({'sendOutSideWNEmailDisabled': true, 'tags': []});
                this.setState({'messageEmailSent': 'Invitation has been sent successfully.'}, () => {
                    window.$('#outsideWNEmailerConfirmPopUp').modal('show');
                });
            }
        }).catch((err) => {
            console.log('error message' + err);
            this.setState({'sendOutSideWNEmailDisabled': false});
            this.setState({'messageEmailSent': err.response.data.message});
            window.$('#outsideWNEmailerConfirmPopUp').modal('show');
        });

    };

    handleDelete(i) {
        const {tags} = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        }, () => {
            if (this.state.tags.length > 0 && this.state.tags.length < 11) {
                this.setState({'sendOutSideWNEmailDisabled': false});
            } else {
                this.setState({'sendOutSideWNEmailDisabled': true});
            }
        });
    }


    handleAddition = (tag) => {
        this.isEmail(tag);
    }

    isEmail = (tag) => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regEmail.test(tag)) {
            return null;
        } else {
            this.verifyWenatMember(tag);
        }
    }

    verifyWenatMember = (tag) => {
        if(this.checkDuplicate(tag)) {
            let {tags} = this.state;
            let emails = [];
            emails.push(tag);
            axios({
                method: 'get',
                url: process.env.REACT_APP_userServiceURL + '/participants/verify/wenatmember/' +
                    "?emails=" + emails,
                headers: {'Content-Type': 'application/json'},
                withCredentials: true
            }).then(response => {
                if (response && response.data && response.data.body && response.data.message === 'Success!') {
                    if (response.data.body.length > 0) {
                        this.setState({'messageEmailSent': response.data.body + ' is already a member at WeNaturalists'}, () => {
                            window.$('#outsideWNEmailerConfirmPopUp').modal('show');
                        });
                    } else {
                        this.setState({tags: [...this.state.tags, {id: tags.length + 1, text: tag}]}, () => {
                            if (this.state.tags.length > 0 && this.state.tags.length < 11) {
                                this.setState({'sendOutSideWNEmailDisabled': false});
                            } else {
                                this.setState({'sendOutSideWNEmailDisabled': true});
                            }
                        });
                    }

                }
            }).catch((err) => {
                console.log(err);
            });
        }

    };


    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        this.setState({tags: newTags});
    }

    checkDuplicate= (emailId) => {
        let emails = [];
        this.state.tags.forEach((tag) => {
            emails.push(tag.text);
        })
        if(emails.includes(emailId)){
            this.setState({'messageEmailSent': 'Duplicate EmailId.'}, () => {
                window.$('#outsideWNEmailerConfirmPopUp').modal('show');
            });
            return false;
        }
        return true;
    }

    onSuccessAllowRestrictPosting = (data, actionType) => {
        let inviteeList = this.state.inviteeList;
        const index = inviteeList && inviteeList.findIndex((item) => item.userId === data.userId);
        if (index > -1) {
            if(actionType === "REMOVE") {
                inviteeList.splice(index, 1);
            } else {
                inviteeList[index].postingRestricted = !data.postingRestricted;
            }
        }
        this.setState({
            inviteeList: inviteeList
        })
    }

    getDonationConfig = (config) => {
        this.setState({
            donationEntityConfig: config
        })
    }

    render() {
        return (
            <div className="col-md-9">
                <OutSideWNEmailConfirmPopUp messageEmailSent={this.state.messageEmailSent}/>
                <div className="projectinn nothidden projdetailscont pdperticipent">
                    <Banner {...this.props} needDonationConfig={true} getDonationConfig={this.getDonationConfig} pageType={"GUEST_INVITEE"} />
                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                    <TopBar {...this.props} />
                    }
                    
                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">

                        <div className="row">
                            <div  class="col-lg-9">
                                {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false && this.props.projectDetail.canInviteFaculty &&
                                <div className="circMemInviteTabwrap"
                                     style={{marginTop: '18px', justifyContent: 'flex-end'}}>
                                    <div className="invtButtns microcommfeed">
                                        <a href="#newInvitepeople" data-toggle="modal" className="btn addofflineproj" onClick={() => {CleverTapUtils.eventClick({}, "Invite New Speaker");}}><i
                                            className="iAdd_Group"/>{this.state.invitePlacementData}</a>
                                        <div id="newInvitepeople" className="modal fade dgpopup" data-backdrop="static"
                                             data-keyboard="false">
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-body">
                                                        <div className="newInvitepeopWrap">
                                                            <button type="button" onClick={this.removefaculties}
                                                                    className="close" data-dismiss="modal"
                                                                    aria-label="Close"><span
                                                                aria-hidden="true">&times;</span></button>
                                                            <div className="pjaddjobsec addfaculty">
                                                                <h4><i className="iAdd_Group"/> {this.state.invitePopUpPlacementData}</h4>
                                                                <div className="form-group">
                                                                    <AutoComplete
                                                                        suggestions={
                                                                            this.state.facultiesSuggestion
                                                                        }
                                                                        onChange={this.onChangeHandlerByNameAndValue}
                                                                        onClick={(e) => {
                                                                            console.log(e);
                                                                        }}
                                                                        key="participant"
                                                                        inputReset={this.state.inputReset}
                                                                        name="participant">
                                                                        <input
                                                                            autoComplete={"none"}
                                                                            type="text"
                                                                            className="form-control custom-input"
                                                                            placeholder="Enter Name"
                                                                        />
                                                                    </AutoComplete>

                                                                </div>
                                                                {this.state.faculties && this.state.faculties.length > 0 &&
                                                                <div className="facultywrap">
                                                                    {this.state.faculties &&
                                                                    this.state.faculties.map((user) => {
                                                                        return (
                                                                            <div className="facultyblk">
                                                                                <div className= {"username" + ( user.userType === "COMPANY" ? " orgnzName" : "")}>
                                                                                    <figure className="user">
                                                                                        <img src={getCDNUrl(user.url)} alt=""/>
                                                                                    </figure>
                                                                                    <span>{" "}
                                                                                    {user.value}</span>
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            this.removeParticipants(user);
                                                                                        }}
                                                                                        className="btn"
                                                                                    >
                                                                                        <i className="iCross_Rounded"
                                                                                           style={{
                                                                                               cursor: 'pointer',
                                                                                               fontSize: '12px',
                                                                                               color: '#698f8a',
                                                                                               margin: '0px 0 0px 3px'
                                                                                           }}/>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                                }
                                                                <button type="button"
                                                                        disabled={(this.state.users && this.state.users.length === 0) || this.state.isSubmited}
                                                                        onClick={this.sendParticipantRequest}
                                                                        className="btn send">Send Invite
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                                {this.props.projectDetail &&
                                this.props.projectDetail.canInviteFacultyOutside &&
                                !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                                    <div className="pdpoutsdinvfrnd">

                                    <div className="outsdinvfrndhdr" onClick={() => {CleverTapUtils.eventClick({}, "Invite friends outside WeNaturalists");}}>
                                        <i className="iAdd_Group"></i><h4>Invite friends outside WeNaturalists</h4>
                                    </div>


                                    <div className="outsdinvfrndbdy">
                                        <div className="tagfield">
                                            <ReactTags
                                                tags={this.state.tags}
                                                key={this.state.hashtagKey}
                                                handleDelete={this.handleDelete}
                                                handleAddition={this.handleAddition}
                                                disabled={this.state.tags.length === 10}
                                                handleDrag={this.handleDrag}
                                                placeholder="Write here..."/>
                                        </div>
                                        <div className="outsdinvfrndftr">
                                            <p>You can add up to 10 email addresses. Press "enter" after each email
                                                address.</p>
                                            <button className="btn send"
                                                    disabled={this.state.sendOutSideWNEmailDisabled}
                                                    onClick={this.sendEmailToOutsideWN}>Send Invite
                                            </button>
                                        </div>
                                    </div>
                                </div>}

                                <div ref={(ref) => this.scrollParentRef = ref}>
                                <div id="scrollableDiv">
                                    {
                                        this.state.inviteeList && this.state.inviteeList.length > 0
                                        && <InfiniteScroll
                                            loadMore={this.fetchMoreFacultyList.bind(this)}
                                            getScrollParent={() => this.scrollParentRef}
                                            hasMore={!this.state.isResultLoading && this.state.pagination}
                                            loader={<h4 className='text-center'>Loading...</h4>}
                                        >
                                            <div className="prof-micocomm-members" style={{marginTop: '20px'}}>
                                                {this.state.inviteeList && this.state.inviteeList.map((user, index) => {
                                                    return <div className={"invitpeopleblk sent" + (user.userType === "COMPANY" ? " orgnzName" : "")} key={index}
                                                                style={{marginBottom: '8px'}}>
                                                        <figure className="users" style={{cursor: 'pointer'}}
                                                                onClick={(e) => {
                                                                    this.redirectToProfile(user.customUrl)
                                                                }}><img
                                                            src={user.originalProfileImage ? getCDNUrl(this.getOptimizedImage(user)) : mappingUtils.returnDefaultImage(user.userType)}
                                                            alt=""/></figure>
                                                        <div>
                                                            <h5 onClick={(e) => {
                                                                this.redirectToProfile(user.customUrl)
                                                            }}>{user.username}</h5>
                                                            {/* {user.city || user.state || user.country &&
                                                    <p>{user.city + ', ' + user.state + ', ' + user.country}</p>
                                                    } */}
                                                            {user.country &&
                                                            <p>{user.country}</p>
                                                            }
                                                        </div>
                                                        <div className="invitpeopbtns">
                                                            {/*<span className="accept"><i className="iFollowTick" /> Accepted</span>*/}
                                                            {(user.status === 'ACCEPTED') &&
                                                            <span className="accept" style={{margin: '0'}}><i
                                                                className="iFollowTick"/> Accepted</span>
                                                            }
                                                            {(user.status === 'Declined') &&
                                                            <span className="accept" style={{margin: '0'}}><i
                                                                className="iFollowTick"/> {user.status}</span>
                                                            }
                                                            {(user.status === 'DELETED') &&
                                                            <span className="accept" style={{margin: '0'}}><i
                                                                className="iFollowTick"/> Declined</span>
                                                            }
                                                            {(user.status === 'DECLINED') &&
                                                            <span className="accept" style={{margin: '0'}}><i
                                                                className="iFollowTick"/> Withdrawn</span>
                                                            }
                                                            {(user.status === 'Revoked') &&
                                                            <span className="accept" style={{margin: '0'}}><i
                                                                className="iFollowTick"/> {user.status}</span>
                                                            }
                                                            {user.withdrawInvite &&
                                                            <div className="pendingWrap">

                                                            <span className="pending"><i
                                                                className="iTime"/> Pending</span>

                                                                <a onClick={() => this.openWidhdrawModal(user.id)}
                                                                   className="cancelinvite btn">Withdraw Invite</a>

                                                            </div>
                                                            }
                                                            <div
                                                                className="modal fade dgpopup confirmpop"
                                                                id={"Withdraw" + user.id}
                                                                tabIndex="-1" role="dialog"
                                                                aria-labelledby="exampleModalLabel"
                                                                aria-hidden="true" data-backdrop="static"
                                                                data-keyboard="false">
                                                                <div className="modal-dialog"
                                                                     role="document">
                                                                    <div className="modal-content">
                                                                        <button type="button"
                                                                                className="close"
                                                                                data-dismiss="modal"
                                                                                aria-label="Close"><span
                                                                            aria-hidden="true">&times;</span>
                                                                        </button>
                                                                        <div
                                                                            className="confirm-popup-modal-body">
                                                                            Are you sure you want to withdraw this
                                                                            invite?
                                                                        </div>
                                                                        <div
                                                                            className="modal-footer confirm-popup-modal-footer">
                                                                            <button type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        this.withdrawFacultyRequest(user)
                                                                                    }}>Yes
                                                                            </button>
                                                                            <button type="button"
                                                                                    className="btn btn-secondary"
                                                                                    data-dismiss="modal">No
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <AllowRestrictRemoveBtn userDetails={user} key={user.userId} onSuccessAllowRestrictPosting={this.onSuccessAllowRestrictPosting} entityId={this.props.projectId}  activeTab={"GUEST_INVITEE"} donationEntityConfig={this.state.donationEntityConfig} />                          
                                                    </div>
                                                })}
                                            </div>
                                        </InfiniteScroll>
                                    }
                            </div>
                                </div>
                            </div>
                            <RightPanel {...this.props}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (details) => dispatch(setProjectDetails(details)),
    };
};


export default connect(null, mapDispatchToProps)(ProjectFacultyContainer);
